var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[[_c('vue-aliplayer-v2',{ref:"VueAliplayerV2",attrs:{"source":_vm.source,"options":_vm.options,"skinLayout":_vm.skinLayout}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }